import React from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {Chatbot} from '../../states/actions';
import {IntNodeComponent, InputComponent, SelectComp} from './Components';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

export const ClassifyBlock = React.memo((node) => {
  const {block, start, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress: progress || []};

  if (!block) {
    return null;
  }
  const {data} = block;

  return (
    <IntNodeComponent bot={bot} name="Classify" icon="match" data={data} node={node} start={start} />
  );
});

export const ClassifyEditor = ({block}) => {
  const {data} = block;

  if (!block) {
    return null;
  }

  const variableoptions = Chatbot.getBlockVariables();

  const handleBlur = (e) => {
    Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
  };

  return (
    <>
      <div className="section">Classify (match v2)</div>
      <SelectComp
        data={data}
        name="Client text variable"
        dataname="textvariable"
        placeholder="Select"
        options={variableoptions}
        block={block}
        value="label"
      />
      <InputComponent
        data={data}
        name="Params profile"
        dataname="paramsprofile"
        placeholder="default"
        onBlur={handleBlur}
      />
      <InputComponent
        data={data}
        name="Data prefix"
        dataname="variableprefix"
        placeholder="mv2"
        onBlur={handleBlur}
      />
    </>
  );
};
